<template>
    <div class="product-intro">
        <div class="wrap">
            <div class="left">
                <ul>
                    <li :class="{active: selected == 1}" @click="selected = 1">房態總覽</li>
                    <li :class="{active: selected == 2}" @click="selected = 2">租約管理</li>
                    <li :class="{active: selected == 3}" @click="selected = 3">線上收租</li>
                    <li :class="{active: selected == 4}" @click="selected = 4">營運資訊</li>
                </ul>
                <img class="shadow" src="@/assets/img/component/product_intro/shadow.png" alt="">
                <img class="shadow-mb" src="@/assets/img/component/product_intro/shadow_mb.png" alt="">
            </div>
            <div class="right">
                <div  v-show="selected == 1" class="content">
                    <div class="title">
                        一目瞭然所有房源的待辦事項
                    </div>
                    <div class="description">
                        飛豬管家彙整所有房源與租約的待辦事項，房東能一眼查看各房源狀態，追蹤預定、收款提醒、租約欠款、合約續約等狀態。
                    </div>
                    <img src="@/assets/img/component/product_intro/one.svg" alt="">
                </div>
                <div  v-show="selected == 2" class="content">
                    <div class="title">
                        提供線上簽約與紙本合約電子化
                    </div>
                    <div class="description">
                        透過飛豬管家預定房源，即可生成合法電子合約與區塊鏈存證，也能將既有紙本合約電子化，享有電子合約的相同功能服務。
                    </div>
                    <img src="@/assets/img/component/product_intro/two.svg" alt="">
                </div>
                <div  v-show="selected == 3" class="content">
                    <div class="title">
                        人性化通知服務與自動生成帳單
                    </div>
                    <div class="description">
                        可以客製化帳單內容、收款提醒、自動催繳等服務，提供房東與房客便利、安全與可靠的管理平台。
                    </div>
                    <img src="@/assets/img/component/product_intro/three.svg" alt="">
                </div>
                <div  v-show="selected == 4" class="content">
                    <div class="title">
                        圖表分析營運狀況與收支紀錄
                    </div>
                    <div class="description">
                        圖像化分析房源空房率與轉化率，提供收入與支出的記帳服務，也能支援線下收租線上紀錄的使用情境。
                    </div>
                    <img src="@/assets/img/component/product_intro/four.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            selected: '1',
        }
    }
}
</script>
<style lang="scss" scoped>
    .product-intro{
        width: 1200px;
        height: 654px;
        border-radius: 20px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.12);
        background-color: #ffffff;
        .wrap{
            display: flex;
            padding: 50px 0;
            .left{
                position: relative;
                width: 280px;
                .shadow{
                    position: absolute;
                    top: -43px;
                    left: 280px;
                }
                .shadow-mb{
                    display: none;
                }
                ul{
                    li{
                        position: relative;
                        cursor: pointer;
                        font-size: 24px;
                        padding: 50px 92px;
                        color: #cacfcd;
                    }
                    li.active{
                        color: #ff9275;
                    }
                    li.active:after{
                        content: '';
                        position: absolute;
                        display: block;
                        top: 43px;
                        right: 0px;
                        width: 4px;
                        height: 40px;
                        border-radius: 2px;
                        background-color: #ff9275;
                    }
                }
            }
            .right{
                position: relative;
                width: 920px;
                display: flex;
                justify-content: center;
                align-items: center;
                .content{
                    padding: 30px 0 23px;
                    width: 500px;
                    display: flex;
                    flex-direction: column;
                    .title{
                        color: #676362;
                        font-size: 24px;
                        text-align: center;
                        margin-bottom: 20px;
                    }
                    .description{
                        font-size: 16px;
                        line-height: 1.75;
                        color: #525956;
                        margin-bottom: 40px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 500px) {
        .product-intro{
            width: 100%;
            height: 100%;
            .wrap{
                display: block;
                padding: 19px 24px;
                .left{
                    position: relative;
                    width: 100%;
                    .shadow{
                        display: none;
                    }
                    .shadow-mb{
                        display: block;
                        position: absolute;
                        top: 36px;
                        width: 100%;
                    }
                    ul{
                        display: flex;
                        margin-bottom: 40px;
                        li{
                            font-size: 16px;
                            padding: 0;
                            margin-right: 34px;
                        }
                        li:last-child{
                            margin-right: 0px;
                        }
                        li.active{
                            color: #ff9275;
                        }
                        li.active:after{
                            content: '';
                            top: 33px;
                            right: 12px;
                            width: 40px;
                            height: 4px;
                        }
                    }
                }
                .right{
                    width: 100%;
                    .content{
                        padding: 30px 0 23px;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        .title{
                            color: #676362;
                            font-size: 20px;
                            text-align: center;
                            margin-bottom: 12px;
                        }
                        .description{
                            font-size: 14px;
                            margin-bottom: 30px;
                        }
                        img{
                            width: 90%;
                            margin: 0 auto;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 375px) {
        .product-intro{
            .wrap{
                .left{
                    ul{
                        li{
                            margin-right: 18px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 360px) {
        .product-intro{
            .wrap{
                padding: 19px 24px;
                .left{
                    .shadow-mb{
                        display: block;
                        position: absolute;
                        top: 36px;
                        width: 100%;
                    }
                    ul{
                        display: flex;
                        margin-bottom: 30px;
                        li{
                            font-size: 14px;
                            padding: 0;
                            margin-right: 15px;
                        }
                        
                        li.active:after{
                            right: 8px;
                        }
                    }
                }
                .right{
                    width: 100%;
                    .content{
                        padding: 30px 0 23px;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        .title{
                            font-size: 18px;
                        }
                        img{
                            width: 100%;
                            margin: 0 auto;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/login/ProductIntro.vue